import React from 'react'

import styled from '@emotion/styled'
import { useForm } from 'react-hook-form'

import { CheckIcon } from '@arcade/web/icons/react'
import { IconMat, Text } from '@cash-design-system/react'
import { PayWithCashAuthorizationBlocker } from '@cash-web/protos/squareup/franklin/blockers/pay_with_cash_authorization_blocker.pb'

import { BaseBlocker, BaseBlockerFormFields, BlockerProps } from '../BaseBlocker/BaseBlocker'

interface Props extends BlockerProps {
  blocker: PayWithCashAuthorizationBlocker
}

const ContentCentered = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  text-align: center;
`

const Spacer = styled.div`
  height: ${({ theme }) => theme.spacing.m};
`

export function BlockerPayWithCashAuthorization({ blocker }: Props): React.ReactElement {
  const form = useForm<BaseBlockerFormFields>()

  const onSubmit = async () => {
    const redirectUrl = blocker.footer?.button_footer?.primary_action?.back_navigation_action?.redirect_url
    if (redirectUrl) {
      window.location.assign(redirectUrl)
    }
  }

  const { title, subtitle } = blocker

  const payingAsText = blocker.on_display_interstitial?.status_interstitial?.text

  return (
    <BaseBlocker mainText={title} secondaryText={subtitle} onSubmit={onSubmit} form={form}>
      <ContentCentered>
        <IconMat>
          <CheckIcon size={24} data-testid="success-icon" />
        </IconMat>
        <Spacer />
        <Text typography="numeralSmall" as="h2" color="textStandard">
          {payingAsText}
        </Text>
      </ContentCentered>
    </BaseBlocker>
  )
}
